<template>
    <v-row justify="center">
        <v-dialog v-model="this.showDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card height="fill">
                <v-card-title class="headline pt-1 pr-1 custom-card-header">
                    Task Details
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="toggle"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="no-bottom-pad">
                    <v-container fluid class="display-flex">
                        <v-flex xs12>
                            <v-card flat class="ma-3">
                                <h1 class="mb-3">Task Information</h1>
                                <v-row>
                                    <v-flex xs4>
                                        <v-text-field class="ma-2" outlined label="Name/Number" v-model="task.taskNumber"></v-text-field>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-autocomplete
                                            label="Status"
                                            :items="statusOptions"
                                            v-model="task.status"
                                            outlined
                                            clearable
                                            class="ma-2"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-autocomplete
                                            label="Order / Pin"
                                            :items="iconIdOptions"
                                            v-model="task.iconId"
                                            outlined
                                            clearable
                                            class="ma-2"
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-row>
                                <v-row>
                                    <v-flex xs6>
                                        <v-text-field class="ma-2" outlined label="Type" v-model="task.taskType"></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-autocomplete
                                            label="Route"
                                            :items="taskRoutes"
                                            :disabled="(task.status === 'Delayed')"
                                            v-model="task.routeId"
                                            hide-no-data
                                            clearable
                                            class="ma-2"
                                            outlined
                                            item-text="name"
                                            item-value="id"
                                            no-data-text="No routes available"
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-row>
                                <v-row>
                                    <v-flex xs12>
                                        <v-text-field class="ma-2" outlined label="Notes" v-model="task.notes"></v-text-field>
                                    </v-flex>
                                </v-row>
                                <v-row>
                                    <v-flex xs6>
                                        <div class="v-input ma-2 v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined ma-2">
                                            <div class="v-input__control">
                                                <div class="v-input__slot">
                                                    <fieldset aria-hidden="true"><legend style="width: 45.25px; color:rgba(0, 0, 0, 0.6); font-size:12px;"><span>Address</span></legend></fieldset>
                                                    <div class="v-text-field__slot">
                                                        <vue-google-autocomplete
                                                            id="task-address"
                                                            class="form-control"
                                                            ref="address"
                                                            :value="task ? task.address : null"
                                                            placeholder="Address"
                                                            :country="['can']"
                                                            v-on:placechanged="getAddressData"
                                                        ></vue-google-autocomplete>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </v-flex>
                                    <v-flex xs3>
                                        <v-text-field
                                            label="Latitude"
                                            v-model="task.latitude"
                                            outlined
                                            class="ma-2"
                                            chips>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs3>
                                        <v-text-field
                                            label="Longitude"
                                            v-model="task.longitude"
                                            outlined
                                            class="ma-2"
                                            chips>
                                        </v-text-field>
                                    </v-flex>
                                </v-row>
                                <v-row>
                                    <v-flex xs4>
                                        <v-dialog
                                            ref="completionDialog"
                                            v-model="completionDateDialog"
                                            :return-value.sync="task.completionDate"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    class="ma-2"
                                                    outlined
                                                    v-model="task.completionDate"
                                                    label="Completion Date"
                                                    prepend-icon="event"
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="task.completionDate" scrollable color="primary">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="completionDateDialog = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="$refs.completionDialog.save(task.completionDate)">OK</v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-dialog
                                            ref="scheduledDialog"
                                            v-model="scheduledDateDialog"
                                            :return-value.sync="task.scheduledDate"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    class="ma-2"
                                                    outlined
                                                    v-model="task.scheduledDate"
                                                    label="Scheduled Date"
                                                    prepend-icon="event"
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="task.scheduledDate" scrollable color="primary">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="scheduledDateDialog = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="$refs.scheduledDialog.save(task.scheduledDate)">OK</v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-dialog
                                            ref="dueDialog"
                                            v-model="dueDateDialog"
                                            :return-value.sync="task.dueDate"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    class="ma-2"
                                                    outlined
                                                    v-model="task.dueDate"
                                                    label="Due Date"
                                                    prepend-icon="event"
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="task.dueDate" scrollable color="primary">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="dueDateDialog = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="$refs.dueDialog.save(task.dueDate)">OK</v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-flex>
                                </v-row>
                                <v-row>
                                    <v-flex xs9>
                                        <v-combobox
                                            label="Tags"
                                            :items="taskTags"
                                            v-model="tagsSelected"
                                            multiple
                                            style="elevation: 0!important;"
                                            chips
                                            class="ma-2"
                                            outlined
                                            item-text="name"
                                            item-value="id"
                                            hide-no-data
                                            clearable
                                        >
                                            <template v-slot:selection="{ attrs, item, select, selected }">
                                                <v-chip
                                                    v-bind="attrs"
                                                    :input-value="selected"
                                                    close
                                                    @click="select"
                                                    @click:close="removeTagFromSelected(item)"
                                                >
                                                    <strong>{{ `${item.name ? item.name : item}` }}</strong>&nbsp;
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </v-flex>
                                    <v-flex xs3>
                                        <v-checkbox class="ma-2 pt-5" outlined label="Two Trip?" v-model="task.twoTrip"></v-checkbox>
                                    </v-flex>
                                </v-row>
                                <br v-if="errorMessage == null"/>
                                <v-row v-if="errorMessage != null">
                                    <v-col xs12><div class="text-center error--text success-message"><b>{{errorMessage}}</b></div></v-col>
                                </v-row>
                                <v-row class="bottom-buttons">
                                    <v-btn color="primary" large class="ma-2" @click="openStreetView">Street View</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" large class="ma-2" @click="updateTask">Update</v-btn>
                                    <v-btn color="primary" outlined large class="ma-2" @click="toggle">Close</v-btn>
                                </v-row>
                            </v-card>
                        </v-flex>
                        <v-flex xs6 class="ma-3">
                            <task-details-map :job-task="selected"></task-details-map>
                        </v-flex>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import Helpers from '@/utils/helpers/jobTaskHelpers'
    import {mapActions, mapGetters} from 'vuex'
    import TaskDetailsMap from '../../components/jobTasks/TaskDetailsMap'
    import VueGoogleAutocomplete from 'vue-google-autocomplete'

    export default {
        name: 'task-details',
        created() {
            this.loadTags()
        },
        components: {
            TaskDetailsMap,
            VueGoogleAutocomplete
        },
        props: {
            showDialog: {
                type: Boolean,
                required: true
            },
            toggle: {
                type: Function,
                required: true
            },
            jobTask: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                createTaskDialog: false,
                scheduledDateDialog: false,
                completionDateDialog: false,
                dueDateDialog: false,
                selectedScheduledDate: "",
                selectedCompletionDate: "",
                selectedDueDate: "",
                tagsSelected: [],
                routeSelected: null,
                statusOptions: Helpers.statuses,
                iconIdOptions: Helpers.iconIdOptions,
                errorMessage: null,
                task: {
                    routeId: null,
                    taskNumber: null,
                    status: null,
                    twoTrip: null,
                    notes: null,
                    address: null,
                    taskType: null,
                    longitude: null,
                    latitude: null,
                    completionDate: new Date().toISOString().substr(0, 10),
                    dueDate: new Date().toISOString().substr(0, 10),
                    scheduleDate: new Date().toISOString().substr(0, 10)
                },
            }
        },
        methods: {
            ...mapActions({
                update: 'jobTasks/update',
                createTag: 'tags/create',
                loadTask: 'jobTasks/getById',
                loadRoutes: 'routes/getAll',
                loadRouteLocations: 'routes/getRouteAndLocations',
                loadIsolatedRoute: 'routes/getIsolatedRoute',
                loadTags: 'tags/getAll'
            }),
            changeAddress() {
                this.task.address = document.querySelector('input[id=map]').value
            },
            async updateTask () {
                if(this.task.taskType == null || this.task.taskType === ''){
                    this.errorMessage = "Task Type cannot be empty"
                    return
                }
                if(this.task.taskNumber == null || this.task.taskNumber === ''){
                    this.errorMessage = "Task Number cannot be empty"
                    return
                }
                if(this.task.status === 'Assigned' && (this.task.routeId == null || this.task.routeId === '')){
                    this.errorMessage = "An assigned task needs to have a route!"
                    return
                }
                if(this.task.status === 'InProgress' && (this.task.routeId == null || this.task.routeId === '')){
                    this.errorMessage = "An in-progress task needs to have a route!"
                    return
                }
                this.errorMessage = null
                this.disabled = true
                if(this.tagsSelected !== []) {
                    this.task.tagIds = []
                    //Handle assigning tags - loop over the results from the combobox
                    if (!Array.isArray(this.tagsSelected)) {
                        this.tagsSelected = [this.tagsSelected]
                    }
                    for (const tagIdx in this.tagsSelected) {
                        const tag = this.tagsSelected[tagIdx]
                        if (typeof tag === 'string') { //String means this is a new tag - create it and use it
                            const data = {
                                name: tag
                            }
                            this.task.tagIds.push(await this.createTag(data))
                        } else if (tag !== null && typeof tag !== 'string' && tag !== undefined) { //This is an existing tag Object - use its id
                            this.task.tagIds.push(tag.id)
                        } else {
                            this.task.tagIds.push(tag)
                        }
                    }
                } else {
                    this.task.tagIds = []
                }
                const savedRouteId = this.task.routeId
                await this.update(this.task)
                if (!this.error && this.task) {
                    if(savedRouteId){
                        await this.loadIsolatedRoute(savedRouteId)
                    }
                    await this.toggle()
                }
                this.disabled = false
            },
            getAddressData (data) {
                const field = document.querySelector('input[id=task-address]').value
                this.task.latitude = data.latitude
                this.task.longitude = data.longitude
                this.task.address = field
            },
            removeTagFromSelected (tag) {
                const index = this.tagsSelected.indexOf(tag);
                if (index > -1) {
                    this.tagsSelected.splice(index, 1);
                }
            },
            openStreetView () {
                const lat = this.task.latitude;
                const lon = this.task.longitude;
                const url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lon}`;
                window.open(url);
            },
        },
        watch: {
            'task.address' (newValue) {
                if (newValue) {
                    if (this.$refs && this.$refs.address) {
                        this.$refs.address.focus();
                        this.$refs.address.update(this.task.address)
                    }
                }
            },
            selected (newValue) {
                if (newValue !== null) {
                    this.task = newValue
                    if(this.task.route){
                        this.task.routeId = this.task.route.id
                    }
                    this.tagsSelected = []
                    if (this.task.jobTaskTags && Array.isArray(this.task.jobTaskTags)) {
                        this.task.jobTaskTags.forEach((jtt) => {
                            if (!(jtt.tag && jtt.tag.name)) {
                                return
                            }
                            this.tagsSelected.push(jtt.tag)
                        })
                    }
                   // this.task.status = Helpers.parseStatus(this.task.status)
                    this.task.completionDate = Helpers.isoDateToYMD(this.task.completionDate)
                    this.task.scheduledDate = Helpers.isoDateToYMD(this.task.scheduledDate)
                    this.task.dueDate = Helpers.isoDateToYMD(this.task.dueDate)
                }
            }
        },
        computed: {
            ...mapGetters({
                selected: 'jobTasks/selectedJobTask',
                taskRoutes: 'routes/routes',
                taskTags: 'tags/tags',
                error: 'jobTasks/error'
            })
        },
    }
</script>
<style scoped>
    .no-bottom-pad {
        padding-bottom: 0 !important;
    }
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
    .display-flex {
        display: flex;
    }
    .bottom-buttons {
        float: bottom;
        text-align: right;
    }
    .showMap {
        visibility: hidden;
        position: absolute;
        top: -100px;
    }
    .hideMap {
        visibility: visible;
        position: relative;
        top: 0;
    }
</style>
